// extracted by mini-css-extract-plugin
export var avatarContainer = "_5i-0";
export var avatarTypingWave = "_5i-i";
export var gray = "_5i-f";
export var green = "_5i-c";
export var icon = "_5i-9";
export var image = "_5i-1";
export var lg = "_5i-6";
export var md = "_5i-5";
export var presenceDot = "_5i-b";
export var red = "_5i-d";
export var sm = "_5i-4";
export var status = "_5i-a";
export var typingDot = "_5i-h";
export var typingPill = "_5i-g";
export var xl = "_5i-7";
export var xs = "_5i-3";
export var xxl = "_5i-8";
export var xxs = "_5i-2";
export var yellow = "_5i-e";